import { useTheme } from "@mui/material";
import { CardCvcElement, CardExpiryElement, CardNumberElement } from "@stripe/react-stripe-js";
import useDebounce from "hooks/useDebounce";
import useOpenClose from "hooks/useOpenClose";
import InputLayout from "library/Layouts/InputLayout";
import { PropTypes } from "prop-types";
import { useCallback, useMemo, useState } from "react";
import styles from "./styles";

const CreditCardInput = ({ onStateChange, variant, ...restProps }) => {
  const theme = useTheme();

  const [error, setError] = useState(null);
  const [focused, setFocus, removeFocus] = useOpenClose(false);

  const Component = useMemo(() => {
    if (variant === "cvc") return CardCvcElement;
    if (variant === "expiry") return CardExpiryElement;
    return CardNumberElement;
  }, [variant]);

  const onChange = useCallback(
    ({ error: err, elementType, complete }) => {
      onStateChange?.(elementType, complete);
      err ? setError(err.message) : setError(null);
    },
    [onStateChange]
  );
  const debouncedOnChange = useDebounce(onChange);

  return (
    <InputLayout error={error} {...restProps}>
      <div className={styles.input({ error, focused })}>
        <Component
          options={{
            style: { base: { fontSize: "12px" }, invalid: { color: theme.palette.error.main } },
            disableLink: true,
          }}
          onChange={debouncedOnChange}
          onFocus={setFocus}
          onBlur={removeFocus}
        />
      </div>
    </InputLayout>
  );
};

CreditCardInput.defaultProps = {
  variant: "card",
};

CreditCardInput.propTypes = {
  onStateChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["cvc", "expiry", "card"]),
};

export default CreditCardInput;
